import { LanguagesType } from 'constants/languages';
import { ReactNode } from 'react';
import { ValueOf } from 'types/custom';
import { SignInData, VerifyOtpData } from 'types/api/auth';

export const ActionTypes = {
  SET_BLOCKED_VISIBLE: 'SET_BLOCKED_VISIBLE',
  SET_LANGUAGES: 'SET_LANGUAGES',
  SET_TMP_TOKEN: 'SET_TMP_TOKEN',
  SIGN_OUT: 'SIGN_OUT'
};

export type LoginForm = {
  email: string;
  password: string;
};

export interface IAuthProps {
  children: ReactNode;
}

export type Action = {
  type: ValueOf<typeof ActionTypes>;
  data: boolean | string | LanguagesType[];
};

export type State = {
  isBlockedVisible: boolean;
  tmpToken: string;
  languages: LanguagesType[];
};

export type PermissionsState = Record<string, number>;

export type SignInReturnType = SignInData;

export type DispatchContext = {
  signOut: () => void;
  signIn: (data: LoginForm) => Promise<SignInData>;
  verify2FA: (otp: string, tmpToken: string) => Promise<VerifyOtpData>;
  getUserData(): void;
  refetchUserData(): void;
};

export type Dispatch = (action: Action) => void;
